import { render, staticRenderFns } from "./DiscoveryTableSingleComponents.vue?vue&type=template&id=5cb97caa&"
import script from "./DiscoveryTableSingleComponents.vue?vue&type=script&lang=js&"
export * from "./DiscoveryTableSingleComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports